<div class="container-fluid" [hidden]="this.showImportDiv == false">
  <div>
    <!-- <div class="card-header bg-white py-3">
      <h1 class="text-gray-800" style="display: inline-block">
        Import Operation Data
      </h1>
      
    </div> -->
    <form #form="ngForm" (ngSubmit)="importRawOpData()" class="mt-4">
    
        <!-- Commented on 14th may 2026 for the breadcrumb changes -->
    <!-- <div class="row mb-3" >
      <div class="col-sm-2" style="text-align: right">
        <label for="name" class="form-label" style="font-weight: bold;color: darkslategrey">Plant:</label>
      </div>
      <div class="col-sm-5">
        <select
          class="form-select border border-dark"
          name="plantid"
          (change)="getSelectedId($event)"
        >
          <option [selected]>Select Plant</option>
          <option *ngFor="let plant of plants" [value]="plant.Id">
            {{ plant.Name }}
          </option>
        </select>
      </div>
    </div> -->



    <!-- <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="train" class="form-label" style="font-weight: bold;color: darkslategrey">Train:</label>
      </div>
      <div class="col-sm-5">
        <select class="form-select border border-dark" name="trainid" 
        (change)="getSelectedTrainId($event)" 
        [(ngModel)]="this.opdataImport.TrainId">
          <option [selected]>Select Train</option>
          <option *ngFor="let train of trains" [value]="train.Id">
            {{ train.Name }}
          </option>
        </select>
      </div>
    </div> -->

    <div class="row mb-3" *ngIf="importMaps.length != 0 && showMaps">
      <div class="col-sm-2" style="text-align: right">
        <label for="importmap" class="form-label" style="font-weight: bold; color: darkslategrey">Import Map (Manage):</label>
      </div>
      <div class="col-sm-5">
        <select
          class="form-select border border-dark"
          name="mapid"
          (change)="mapImportFields($event)"         
        >
          <option [selected]>Select One</option>
          <option *ngFor="let importMap of importMaps" [value]="importMap.Id">
            {{ importMap.Name }}
          </option>
        </select>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="importfile" style="font-weight: bold;color: darkslategrey">Import File</label>
        <label for="info" style="font-style: italic; color: darkslategrey"
          >(Spreadsheet file must have < 10 tabs) Please limit dataset to < 5000
          points</label
        >
      </div>
      <div class="col-sm-5">
        <input
          type="file"
          class="form-control border border-dark"
          id="importfile"
          (change)="onFileSelected($event)" 
        />
      </div>      
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
      <label for="sync" style="font-weight: bold;color: darkslategrey">Sync</label></div>
      <div class="col-sm-1">
        <input type="radio" id="html" name="fav_language" value="HTML" 
        (change)="setSyncOption('1')" [checked]="this.syncOption == '1'" />
        <label for="html">Alert</label>
      </div>
      <div class="col-sm-2">
        <input type="radio" id="css" name="fav_language" value="CSS"
        (change)="setSyncOption('2')"  [checked]="this.syncOption == '2'"/>
        <label for="css">Replace Existing</label><br />
      </div>
      <div class="col-sm-2">
        <input
          type="radio"
          id="javascript"
          name="fav_language"
          value="JavaScript"
          (change)="setSyncOption('3')"
          [checked]="this.syncOption == '3'"
        />
        <label for="javascript">Delete All Existing</label>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="worksheet" class="form-label" style="font-weight: bold; color: darkslategrey">Work Sheet</label>
      </div>
      <div class="col-sm-5">
        <input
          type="text"
          class="form-control border border-dark"
          id="worksheet"
          name="worksheet"
          autocomplete="on" [(ngModel)]='opdataImport.Worksheet'
        />
      </div>
    </div>

    <!-- <div class="row mb-3">
        <div class="col-sm-2" style="text-align: right">
          <label for="colforstage" class="form-label">Column for Stage</label>
        </div>
        <div class="col-sm-5">
          <select class="form-select border border-dark" name="colforstage">
            <option value="0">A</option>
            <option value="1">B</option>
            <option value="2">C</option>
            <option value="3">D</option>
          </select>
        </div>
      </div> -->

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="FNDR" class="form-label" style="font-weight: bold; color: darkslategrey">First Numerical Data Row</label>
      </div>
      <div class="col-sm-5">
        <input
          type="text"
          class="form-control border border-dark"
          id="FNDR"
          name="FNDR"
          autocomplete="on"
          [(ngModel)]='opdataImport.HeaderRow'
        />
      </div>
    </div>

    <div>
    <div class="row mb-3"> <div class="col-sm-2" style="text-align: right"><label for="mapcol" class="form-label" style="font-weight: bolder; color: darkslategrey">Map Columns</label></div> <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey">Date</label> </div> <div class="col-sm-1"><input type="text" class="form-control border border-dark" id="Date" name="Date" [(ngModel)]='this.dateCol' autocomplete="on"/></div></div>
    <div class="row mb-3"> <div class="col-sm-2" style="text-align: right"> </div> <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey">Time</label> </div> <div class="col-sm-1"><input type="text" class="form-control border border-dark" id="Time" name="Time" autocomplete="on" [(ngModel)]='this.timeCol'/></div></div>
    <div class="row mb-3"> <div class="col-sm-2" style="text-align: right"> </div> <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey">Feed pH</label> </div> <div class="col-sm-1"><input type="text" class="form-control border border-dark" id="FeedpH" name="FeedpH" autocomplete="on" [(ngModel)]='this.phCol'/></div></div>
    <div class="row mb-3"> <div class="col-sm-2" style="text-align: right"> </div> <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey">Feed Temperature</label> </div> <div class="col-sm-1"><input type="text" class="form-control border border-dark" id="FeedTemp" name="FeedTemp" autocomplete="on" [(ngModel)]='this.tempCol'/></div></div>
    <div class="row mb-3"> <div class="col-sm-2" style="text-align: right"> </div> <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey">Stage 1: Concentrate Flow</label> </div> <div class="col-sm-1"><input type="text" class="form-control border border-dark" id="Stage1ConcentFlow" name="Stage1ConcentFlow" autocomplete="on" [(ngModel)]='this.s1concflowCol'/></div></div>
    <div class="row mb-3"> <div class="col-sm-2" style="text-align: right"> </div> <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey">Stage 1: Permeate Flow</label> </div> <div class="col-sm-1"><input type="text" class="form-control border border-dark" id="Stage1PermFlow" name="Stage1PermFlow" autocomplete="on" [(ngModel)]='this.s1permflowCol'/></div></div>
    <div class="row mb-3"> <div class="col-sm-2" style="text-align: right"> </div> <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey">Stage 1: Feed Pressure</label> </div> <div class="col-sm-1"><input type="text" class="form-control border border-dark" id="Stage1FeedPress" name="Stage1FeedPress" autocomplete="on" [(ngModel)]='this.s1feedpressCol'/></div></div>
    <div class="row mb-3"> <div class="col-sm-2" style="text-align: right"> </div> <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey">Stage 1: Concentrate Pressure</label> </div> <div class="col-sm-1"><input type="text" class="form-control border border-dark" id="Stage1ConcentPress" name="Stage1ConcentPress" autocomplete="on" [(ngModel)]='this.s1concpressCol'/></div></div>
    <div class="row mb-3"> <div class="col-sm-2" style="text-align: right"> </div> <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey">Stage 1: Permeate Pressure</label> </div> <div class="col-sm-1"><input type="text" class="form-control border border-dark" id="Stage1PermPress" name="Stage1PermPress" autocomplete="on" [(ngModel)]='this.s1permpressCol'/></div></div>
    <div class="row mb-3"> <div class="col-sm-2" style="text-align: right"> </div> <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey">Stage 1: Feed Conductivity</label> </div> <div class="col-sm-1"><input type="text" class="form-control border border-dark" id="Stage1FeedConduct" name="Stage1FeedConduct" autocomplete="on" [(ngModel)]='this.s1feedcondCol'/></div></div>
    <div class="row mb-3"> <div class="col-sm-2" style="text-align: right"> </div> <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey">Stage 1: Permeate Conductivity</label> </div> <div class="col-sm-1"><input type="text" class="form-control border border-dark" id="Stage1PermConduct" name="Stage1PermConduct" autocomplete="on" [(ngModel)]='this.s1permcondCol'/></div></div>
    <div class="row mb-3" [hidden]="this.noOfStages < 2"> <div class="col-sm-2" style="text-align: right"> </div> <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey">Stage 2: Concentrate Flow</label> </div> <div class="col-sm-1"><input type="text" class="form-control border border-dark" id="Stage2ConcentFlow" name="Stage2ConcentFlow" autocomplete="on" [(ngModel)]='this.s2concflowCol'/></div></div>
    <div class="row mb-3" [hidden]="this.noOfStages < 2"> <div class="col-sm-2" style="text-align: right"> </div> <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey">Stage 2: Permeate Flow</label> </div> <div class="col-sm-1"><input type="text" class="form-control border border-dark" id="Stage2PermeFlow" name="Stage2PermeFlow" autocomplete="on" [(ngModel)]='this.s2permflowCol'/></div></div>
    <div class="row mb-3" [hidden]="this.noOfStages < 2"> <div class="col-sm-2" style="text-align: right"> </div> <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey">Stage 2: Feed Pressure</label> </div> <div class="col-sm-1"><input type="text" class="form-control border border-dark" id="Stage2FeedPress" name="Stage2FeedPress" autocomplete="on" [(ngModel)]='this.s2feedpressCol'/></div></div>
    <div class="row mb-3" [hidden]="this.noOfStages < 2"> <div class="col-sm-2" style="text-align: right"> </div> <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey">Stage 2: Concentrate Pressure</label> </div> <div class="col-sm-1"><input type="text" class="form-control border border-dark" id="Stage2ConcentPress" name="Stage2ConcentPress" autocomplete="on" [(ngModel)]='this.s2concpressCol'/></div></div>
    <div class="row mb-3" [hidden]="this.noOfStages < 2"> <div class="col-sm-2" style="text-align: right"> </div> <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey">Stage 2: Permeate Pressure</label> </div> <div class="col-sm-1"><input type="text" class="form-control border border-dark" id="Stage2PermPress" name="Stage2PermPress" autocomplete="on" [(ngModel)]='this.s2permpressCol'/></div></div>
    <!-- <div class="row mb-3" [hidden]="this.noOfStages < 2"> <div class="col-sm-2" style="text-align: right"> </div> <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey">Stage 2: Feed Conductivity</label> </div> <div class="col-sm-1"><input type="text" class="form-control border border-dark" id="Stage2FeedConduct" name="Stage2FeedConduct" autocomplete="on" [(ngModel)]='this.s2feedcondCol'/></div></div> -->
    <div class="row mb-3" [hidden]="this.noOfStages < 2"> <div class="col-sm-2" style="text-align: right"> </div> <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey">Stage 2: Permeate Conductivity</label> </div> <div class="col-sm-1"><input type="text" class="form-control border border-dark" id="Stage2PermConduct" name="Stage2PermConduct" autocomplete="on" [(ngModel)]='this.s2permcondCol'/></div></div>
    <div class="row mb-3" [hidden]="this.noOfStages < 3"> <div class="col-sm-2" style="text-align: right"> </div> <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey">Stage 3: Concentrate Flow</label> </div> <div class="col-sm-1"><input type="text" class="form-control border border-dark" id="Stage3ConcenFlow" name="Stage3ConcenFlow" autocomplete="on" [(ngModel)]='this.s3concflowCol'/></div></div>
    <div class="row mb-3" [hidden]="this.noOfStages < 3"> <div class="col-sm-2" style="text-align: right"> </div> <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey">Stage 3: Permeate Flow</label> </div> <div class="col-sm-1"><input type="text" class="form-control border border-dark" id="Stage3Permlow" name="Stage3Permlow" autocomplete="on" [(ngModel)]='this.s3permflowCol'/></div></div>
    <div class="row mb-3" [hidden]="this.noOfStages < 3"> <div class="col-sm-2" style="text-align: right"> </div> <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey">Stage 3: Feed Pressure</label> </div> <div class="col-sm-1"><input type="text" class="form-control border border-dark" id="Stage3FeedPress" name="Stage3FeedPress" autocomplete="on" [(ngModel)]='this.s3feedpressCol'/></div></div>
    <div class="row mb-3" [hidden]="this.noOfStages < 3"> <div class="col-sm-2" style="text-align: right"> </div> <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey">Stage 3: Concentrate Pressure</label> </div> <div class="col-sm-1"><input type="text" class="form-control border border-dark" id="Stage3ConcentPress" name="Stage3ConcentPress" autocomplete="on" [(ngModel)]='this.s3concpressCol'/></div></div>
    <div class="row mb-3" [hidden]="this.noOfStages < 3"> <div class="col-sm-2" style="text-align: right"> </div> <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey">Stage 3: Permeate Pressure</label> </div> <div class="col-sm-1"><input type="text" class="form-control border border-dark" id="Stage3PermPress" name="Stage3PermPress" autocomplete="on" [(ngModel)]='this.s3permpressCol'/></div></div>
    <!-- <div class="row mb-3" [hidden]="this.noOfStages < 3"> <div class="col-sm-2" style="text-align: right"> </div> <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey">Stage 3: Feed Conductivity</label> </div> <div class="col-sm-1"><input type="text" class="form-control border border-dark" id="Stage3FeedConduct" name="Stage3FeedConduct" autocomplete="on" [(ngModel)]='this.s3feedcondCol'/></div></div> -->
    <div class="row mb-3" [hidden]="this.noOfStages < 3"> <div class="col-sm-2" style="text-align: right"> </div> <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey">Stage 3: Permeate Conductivity</label> </div> <div class="col-sm-1"><input type="text" class="form-control border border-dark" id="Stage3PermCond" name="Stage3PermCond" autocomplete="on" [(ngModel)]='this.s3permcondCol'/></div></div>
    
    <div *ngIf="showUserDefinedDiv">
    <div class="row mb-3"> 
      <div class="col-sm-2" style="text-align: right"> 
      </div> 
      <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey"
          *ngIf="showUserDefinedField1">User Defined 1</label>
      </div>
      <div class="col-sm-1">
        <input type="text" class="form-control border border-dark" id="UserDef1" name="UserDef1" autocomplete="on"
          [(ngModel)]='this.UD1Col' *ngIf="showUserDefinedField1" />
      </div>
      </div>
    <div class="row mb-3"> <div class="col-sm-2" style="text-align: right"> </div> <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey" *ngIf="showUserDefinedField2" >User Defined 2</label> </div> <div class="col-sm-1"><input type="text" class="form-control border border-dark" id="UserDef2" name="UserDef2" autocomplete="on" *ngIf="showUserDefinedField2" [(ngModel)]='this.UD2Col'/></div></div>
    <div class="row mb-3"> <div class="col-sm-2" style="text-align: right"> </div> <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey" *ngIf="showUserDefinedField3">User Defined 3</label> </div> <div class="col-sm-1"><input type="text" class="form-control border border-dark" id="UserDef3" name="UserDef3" autocomplete="on" *ngIf="showUserDefinedField3" [(ngModel)]='this.UD3Col'/></div></div>
    <div class="row mb-3"> <div class="col-sm-2" style="text-align: right"> </div> <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey" *ngIf="showUserDefinedField4">User Defined 4</label> </div> <div class="col-sm-1"><input type="text" class="form-control border border-dark" id="UserDef4" name="UserDef4" autocomplete="on" *ngIf="showUserDefinedField4" [(ngModel)]='this.UD4Col'/></div></div>
    <div class="row mb-3"> <div class="col-sm-2" style="text-align: right"> </div> <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey" *ngIf="showUserDefinedField5">User Defined 5</label> </div> <div class="col-sm-1"><input type="text" class="form-control border border-dark" id="UserDef5" name="UserDef5" autocomplete="on" *ngIf="showUserDefinedField5"[(ngModel)]='this.UD5Col'/></div></div>
    </div>
    <div class="row mb-3"> <div class="col-sm-2" style="text-align: right"> </div> <div class="col-sm-4"> <label for="mapcol" style="font-weight: bold; color: darkslategrey">Comments</label> </div> <div class="col-sm-1"><input type="text" class="form-control border border-dark" id="Comments" name="Comments" autocomplete="on" [(ngModel)]='this.commentsCol'/></div></div>
</div>

<div>    <label for="javascript">&nbsp;</label></div>
<div class="row mb-3">
  <div class="col-sm-2" style="text-align: right">
  <label for="sync" style="font-weight: bold;color: darkslategrey">Save Import Map</label></div>
  <div class="col-sm-2">
    <input type="checkbox" id="chkSaveImpMap" name="chkSaveImpMap" value="Save Import Map" 
    [checked]="this.saveMap" 
    (change)="setImageMap($event)"  />
  </div>
  <div class="col-sm-2">
    
  </div>
  <div class="col-sm-2">
    
  </div>
</div>
<div class="row mb-3" [hidden]="!this.saveMap">
  <div class="col-sm-2" style="text-align: right">
    <label for="worksheet" class="form-label" style="font-weight: bold; color: darkslategrey">Import Map Name</label>
  </div>
  <div class="col-sm-5">
    <input
      type="text"
      class="form-control border border-dark"
      id="mapname"
      name="mapname"
      autocomplete="on" [(ngModel)]='this.mapname'
    />
  </div>
</div>



    <div class="row">
      <div class="col-sm-6" style="text-align: right">
        <button type="submit" class="btn custom-buttons-btn mt-3">Import</button>
        <!-- <button type="submit" class="btn btn-primary mt-3">Submit</button> -->
      </div>
      <div class="col-sm-2" style="text-align: left">
        <button type="button" class="btn custom-buttons-btn mt-3">Reset</button>
      </div>
    </div>
</form>

  </div>
</div>

<div class="container-fluid" [hidden]="this.showAlert == false">
  <div class="col-sm-3" style="text-align: left">
    
    <button (click)="retrunToImport()" type="button" class="btn custom-buttons-btn mt-3">Return to Import Page</button>
    &nbsp;&nbsp;
    <button (click)="retrunToManage(this.plantId, this.trainId)" type="button" class="btn custom-buttons-btn mt-3">View Op Data</button>
  </div>

  <div>
    <div class="card-header py-3">
      <h1 class="text-gray-800" style="display: inline-block">
        Import Operation Data Errors
      </h1>
    </div>
    <table
        class="table table-bordered"
        width="100%"
        *ngIf="this.errorsList && this.errorsList.length > 0">
        <tbody>
          <tr *ngFor="let err of this.errorsList">
            <td>{{err}}</td>
            <td>&nbsp;</td>
            <td>A duplicate entry was detected</td>
      
        </tbody>
      </table>

  </div>

</div>
